import { useState, useEffect } from "react";
import { Frame, Loading, Header, Input, ValidaUid } from "../components";
import { useNavigate } from "react-router-dom";
import { ValidaForm3 } from "../components/Validacao";
import { db, auth, storage } from "../config/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { Image, Row, Col, Card } from "react-bootstrap";
import Boneco from "../assets/boneco.png";

const Form3 = () => {
  const [erro, setErro] = useState({});
  const [dados, setDados] = useState({});
  const [loading, setLoading] = useState(true);

  let uid = auth.currentUser?.uid;

  const navigate = useNavigate();

  const uploadFile = async (file, docPath, docUrl) => {
    if (!file) return;

    setLoading(true);

    const path = ref(storage, `desconto2026/${uid}/${docPath}`);

    const upload = uploadBytesResumable(path, file, file.type);

    upload.on(
      "state_changed",
      () => {},
      () => {},
      () => {
        getDownloadURL(upload.snapshot.ref).then((url) => {
          setDados({ ...dados, [docUrl]: url });
          setLoading(false);
        });
      },
    );
  };

  const setData = async () => {
    await setDoc(doc(db, "desconto2026", uid), dados, { merge: true });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    const err = ValidaForm3(dados);

    if (err) {
      setErro(err);
      setLoading(false);
    } else {
      setData().then(() => navigate("../form4"));
    }
  };

  const buscaDados = async () => {
    const uid = await ValidaUid();

    if (uid) {
      const qry = await getDoc(doc(db, "desconto2026", uid));

      const data = qry.data();

      if (!data?.status) {
        setLoading(false);
      } else if (data?.status === "e") {
        setLoading(false);
        setDados(data);
      } else {
        navigate("../home");
      }
    }
  };

  useEffect(() => {
    buscaDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading && <Loading />}
      <Header nome={dados?.nome} foto={dados?.urlFoto} />
      <Frame
        body={
          <form
            autoComplete="off"
            onSubmit={handleSubmit}
            className="text-start"
            noValidate
          >
            <Image
              src={Boneco}
              alt="Imagem"
              height={300}
              className="d-block mx-auto"
            />

            <div className="d-flex justify-content-center">
              <div className="p-3 text-center">
                <Card.Title>
                  A foto deve seguir os seguintes requisitos:
                </Card.Title>

                <ul className="list-unstyled mt-3">
                  <li>Apenas o rosto visível ✔</li>
                  <li>Fundo neutro ✔</li>
                  <li>Sem acessórios ✔</li>
                  <li>Local bem iluminado ✔</li>
                </ul>
              </div>
            </div>

            <Row className="mt-3 justify-content-center">
              <Col sm="6">
                <Input
                  id="urlFoto"
                  type="file"
                  accept=".jpg, .jpeg, .png, .pdf"
                  className={erro.foto && "is-invalid"}
                  onChange={(e) =>
                    uploadFile(e.target.files[0], "foto", "urlFoto")
                  }
                  erro={erro.foto}
                  url={dados?.urlFoto}
                />
              </Col>
            </Row>
            <Row className="mt-3 justify-content-center">
              <Col sm="6" className="d-grid">
                <button type="submit" className="btn btn-primary">
                  ENVIAR
                </button>
              </Col>
            </Row>
          </form>
        }
        title="Foto para Carteirinha"
      />
    </>
  );
};

export default Form3;
